import MenuMapping from './MenuMapping';

function MappingsCell({ globalProps, row, key, types }: any) {
    return (
        <MenuMapping
            types={types}
            t={globalProps.t}
            menuStructure={row.original[key]}></MenuMapping>
    );
}
export default MappingsCell;
